var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurniture6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.626,
    height: 52.807,
    viewBox: "0 0 26.626 52.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7743",
    "data-name": "Grupo 7743",
    transform: "translate(-63.657 -46.221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2100",
    "data-name": "Ret\\xE2ngulo 2100",
    width: 24.461,
    height: 18.637,
    rx: 4,
    transform: "translate(65.094 47.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_22",
    "data-name": "Uni\\xE3o 22",
    d: "M18.831,52.507a1.851,1.851,0,0,1-1.853-1.845V47.922H9.346v2.741A1.847,1.847,0,0,1,7.5,52.507H5.624a1.846,1.846,0,0,1-1.844-1.845V47.92A3.893,3.893,0,0,1,0,44.034V23.786c0-.026,0-.052,0-.078V3.887A3.893,3.893,0,0,1,3.891,0H22.44a3.892,3.892,0,0,1,3.887,3.887v19.9c0,.019,0,.037,0,.056V44.034a3.893,3.893,0,0,1-3.772,3.886v2.742A1.851,1.851,0,0,1,20.7,52.507Zm.137-1.991h1.6V47.922h-1.6Zm-13.2,0H7.357V47.922H5.77ZM1.99,44.034a1.9,1.9,0,0,0,1.9,1.9H22.436a1.9,1.9,0,0,0,1.9-1.9V24.78H1.99ZM24.336,22.79V20.762H1.993V22.79ZM1.993,3.887V18.77H24.336V3.887a1.9,1.9,0,0,0-1.9-1.9H3.891A1.9,1.9,0,0,0,1.993,3.887ZM3.072,32.106V27.977a2.381,2.381,0,0,1,4.762,0v4.128a2.381,2.381,0,0,1-4.762,0Zm1.99-4.128v4.128a.392.392,0,0,0,.783,0V27.977a.392.392,0,0,0-.783,0Zm-1.99-13.4V10.451a2.381,2.381,0,1,1,4.762,0v4.128a2.381,2.381,0,0,1-4.762,0Zm1.99-4.128v4.128a.392.392,0,0,0,.783,0V10.451a.392.392,0,1,0-.783,0Z",
    transform: "translate(63.807 46.371)",
    fill: "#153c8b",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture6);
export default __webpack_public_path__ + "static/media/furniture-6.cf2b5b25e9938f9fd479a4fee3f19a86.svg";
export { ForwardRef as ReactComponent };